import { cn } from "@/lib/cn";

export function ProgressBar({
  value,
  tone = "primary",
  className,
}: {
  /** 0–100 */
  value: number;
  tone?: "primary" | "success" | "warning" | "danger";
  className?: string;
}) {
  const colors = {
    primary: "bg-primary",
    success: "bg-success",
    warning: "bg-warning",
    danger: "bg-danger",
  } as const;
  return (
    <div className={cn("h-[6px] rounded-pill bg-bg4 overflow-hidden", className)}>
      <div
        className={cn("h-full rounded-pill transition-[width] duration-500", colors[tone])}
        style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
      />
    </div>
  );
}
